import React from 'react';
import Box, { TBoxProps } from '../Box/Box';

import { TBadgeSignals } from '../../types/TEBadgeSignal';

export type TBadge = {
  signal: TBadgeSignals;
  children?: React.ReactNode;
} & Pick<TBoxProps, 'className' | 'utilities'>;

const Badge = ({ signal, ...rest }: TBadge) => <Box {...rest} as="div" name="Badge" modifiers={signal} />;

export default Badge;
